import { useEffect, useRef } from 'react';

import { notifyWrapperSelector } from 'shared/notifier/ui';

export const useOutsideClick = <T extends HTMLDivElement | HTMLInputElement>(callback: () => void) => {
  const refElement = useRef<T>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as HTMLDivElement;
      //Чтобы при клике на уведомление не закрывалось модалка
      const excludeElement = document.querySelector(`.${notifyWrapperSelector}`);

      if (refElement.current && !refElement.current.contains(target) && (!excludeElement || !excludeElement.contains(target))) {
        callback();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [refElement, callback]);

  return { refElement };
};
